/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
export enum ProfileTabs {
  Index,
  Notifications,
  Security,
  DeleteAccount,
}

export const tabToRouteBinding = {
  [ProfileTabs.Index]: '/profile',
  [ProfileTabs.Notifications]: 'notifications',
  [ProfileTabs.Security]: 'security',
  [ProfileTabs.DeleteAccount]: 'delete-account',
};
